<template>
  <div class="app-activation-tariff-options">
    <h1>HELLO</h1>
    <slot name="txtHeader"><h1>TARIFOPTIONEN AUSWÄHLEN</h1></slot>
    <div class="tariff-options-wrapper">
      <label :data-disabled="isDisabled(tariffOption)" :for="'option-'+ tariffOption.tariffOptionId " v-for="tariffOption in tariffOptions" :key="tariffOption.tariffOptionId" class="tariff-option-box" :id="tariffOption.tariffOptionId">
        <div class="option" >
          <div class="option-box">
          <div class="image">
            <img v-if="tariffOption.icon" :src="tariffOption.icon">
          </div>
          <div class="checkbox-label">
            <span v-html="tariffOption.tariffOptionName"></span>
            <span v-if="tariffOption.extraHtml" v-html="tariffOption.extraHtml"></span>
            <div class="option-info">
              <p v-if="tariffOption.desc" v-html="tariffOption.desc">
              </p>
            </div>
          </div>
          </div>
        </div>
        <div class="info">
          <div class="info-box">
          <span class="option-info">
            {{ price(tariffOption.price) }} / {{tariffOption.duration.amount}} {{ durationUnit(tariffOption.duration.unit, tariffOption.duration.amount) }}
          </span>
          <div v-if="tariffOption.info"
               v-b-tooltip.hover.bottom="{customClass: 'wide-tooltip'}" :title="tariffOption.info"
               class="info-bubble">
            <img class="hover-toggle" :src="tariffOption.infoBubbleImage">
          </div>
          </div>
        </div>
        <div class="input-checkbox">
          <input type="checkbox"
                 :id="'option-' + tariffOption.tariffOptionId"
                 v-model="selectedTariffOptions"
                 :value="tariffOption"
                 :name="'option-' + tariffOption.tariffOptionId"
                 class="tariff-box"
                 @change="selectOption(tariffOption)">
        </div>
      </label>
    </div>
    <div class="sum-wrapper">
      <slot name="txtSum"><span>Summe</span></slot>
      <div class="sum"> {{ price(totalSum) }} </div>
    </div>
    <div class="buttons">
      <b-button class="btn-back" variant="primary" type="button" v-on:click.prevent="back">
        <slot name="btnBackLabel">zurück</slot>
      </b-button>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button :id="'submit-'+_uid" type="submit" variant="primary"
                  :disabled="loading"
                  @click="saveSelectedTariffOptions()"
        >
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import processSteps from '@/mixins/processSteps'
import { stepName as previousProcessStep } from '../PersonalData/PersonalDataInput.vue'
import { stepName as nextProcessStep } from '../Success/Success.vue'
import preFilledInput from '@/mixins/preFilledInput'
import price from '@/mixins/price'
import durationUnit from '@/mixins/durationUnit'
export const stepName = 'tariffOptions'

export default {
  name: 'ActivationTariffOptions',
  mixins: [
    processSteps(stepName, previousProcessStep, nextProcessStep),
    preFilledInput('selectedTariffOptions', 'savedTariffOptions'),
    price,
    durationUnit
  ],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('activation/info', [
      'availableTariffOptions',
      'getPreactivatedTariff'
    ]),
    ...mapGetters('activation/tariffOptions', [
      'savedTariffOptions'
    ]),
    tariffOptions: function () {
      const tariffOptions = []
      const me = this
      this.availableTariffOptions.forEach((tariffOption) => {
        if (me.extraData.additionalData[tariffOption.tariffOptionId]) {
          const extraDataInfo = me.extraData.additionalData[tariffOption.tariffOptionId]
          const tariffOptionObject = Object.assign({}, tariffOption, extraDataInfo)
          tariffOptions.push(tariffOptionObject)
        }
      })
      return tariffOptions
    },
    disabledTariffOptions: function () {
      const disabledOptions = []
      this.selectedTariffOptions.forEach(function (tariffOption) {
        tariffOption.notBookableWith.forEach(function (disableOption) {
          disabledOptions.push(disabledOptions)
        })
      })
      return disabledOptions
    },
    totalSum: function () {
      let sum = 0
      this.selectedTariffOptions.forEach(function (tariffOption) {
        sum = sum + tariffOption.price
      })
      return sum
    }
  },
  props: {
    extraData: {
      type: Object
    }
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/tariffOptions', [
      'selectTariffOptions'
    ]),
    back () {
      this.goToStep(this.previousStep)
    },
    selectOption (tariffOption) {
      const me = this
      tariffOption.notBookableWith.forEach(option => {
        const index = me.selectedTariffOptions.findIndex(tariffOption => {
          return tariffOption.tariffOptionId === option
        })
        if (index > -1) {
          me.selectedTariffOptions.splice(index, 1)
        }
      })
    },
    isDisabled (tariffOption) {
      return this.disabledTariffOptions.find(function (checkOption) {
        return checkOption.tariffOptionId === tariffOption.tariffOptionId
      }) !== undefined
    },
    saveSelectedTariffOptions () {
      this.loading = true
      this.selectTariffOptions({
        selectedTariffOptions: this.selectedTariffOptions,
        nextStep: this.nextStep
      })
      this.loading = false
    }
  }
}
</script>
